export default __webpack_public_path__ + "static/media/control-da.cdecaae2.png";